module.exports = __webpack_public_path__ + "static/img/brand5.1aa968d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand5.png
// module id = HkcR
// module chunks = 1